import { h } from '@stencil/core/internal/client';
import { X as buttonSecondary, Y as buttonPrimary, Z as buttonLoading } from './parts.js';

const ButtonSpinner = () => (h("div", { class: "spinner-border spinner-border-sm", role: "status", part: "button-spinner" },
    h("span", { class: "visually-hidden" }, "Loading...")));

const Button = (props, children) => {
    const variantToButton = {
        primary: buttonPrimary,
        secondary: buttonSecondary,
    };
    const getCSSParts = () => {
        return `${variantToButton[props.variant]} ${(props.isLoading) ? buttonLoading : ''}`;
    };
    return (h("button", Object.assign({ class: `btn btn-${props.variant}`, onClick: props.clickHandler, part: getCSSParts() }, props), props.isLoading ? ButtonSpinner() : children));
};

export { Button as B };
